import { AppState } from '../index';

export const getSelectedReports = (state: AppState) => state.userPrefs.selectedReports;

export const getShareUrl = (state: AppState) => state.userPrefs.shareUrl;

export const getIsHeaderExpanded = (state: AppState) => state.userPrefs.headerExpanded;

export const getIsShareDialogOpen = (state: AppState) => state.userPrefs.shareDialogOpen;
